import {
  CONFERENCES_LIST_PAGE_SET_LOADING,
  SEARCH_CONFERENCES_LIST_PAGE_FAIL,
  SEARCH_CONFERENCES_LIST_PAGE_SUCCESS,
  SEARCH_CONFERENCES_LIST_PAGE_START,
  CONFERENCES_LIST_PAGE_SEARCH_USERS_START,
  CONFERENCES_LIST_PAGE_SEARCH_USERS_SUCCESS,
  CONFERENCES_LIST_PAGE_SEARCH_USERS_FAIL,
  CONFERENCES_LIST_PAGE_ACTIVE_USERS_FILTERS,
  CONFERENCES_LIST_PAGE_RESET_USER_FILTERS,
} from '@xmatters/redux/actions/conferenceList';
import { getListPageSuccessNewData } from 'reducers/utils';
import { getConference } from './util';

export const defaultState = {
  listLoading: true,
  dataLoaded: false,
  error: false,
  data: [],
  total: 0,
  users: {
    total: 0,
    data: [],
    loading: false,
    activeItems: [],
  },
};

export default function conferenceListReducer(state = defaultState, action) {
  switch (action.type) {
    case CONFERENCES_LIST_PAGE_SET_LOADING: {
      return {
        ...state,
        listLoading: true,
      };
    }
    case SEARCH_CONFERENCES_LIST_PAGE_START: {
      return {
        ...state,
        dataLoaded: false,
      };
    }
    case SEARCH_CONFERENCES_LIST_PAGE_SUCCESS: {
      const { data, links } = action.payload;
      const conferences = data.map(conference => getConference(conference));
      const newData = getListPageSuccessNewData(state, conferences, links);

      return {
        ...state,
        total: action.payload.total,
        data: newData,
        listLoading: false,
        dataLoaded: true,
      };
    }
    case SEARCH_CONFERENCES_LIST_PAGE_FAIL:
      return {
        ...state,
        error: true,
      };
    case CONFERENCES_LIST_PAGE_SEARCH_USERS_SUCCESS: {
      const { data, total } = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          data,
          total,
          loading: false,
        },
      };
    }
    case CONFERENCES_LIST_PAGE_SEARCH_USERS_START: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
        },
      };
    }
    case CONFERENCES_LIST_PAGE_SEARCH_USERS_FAIL: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
        },
      };
    }
    case CONFERENCES_LIST_PAGE_ACTIVE_USERS_FILTERS: {
      const { payload } = action;
      const activeItems = [
        ...state.users.activeItems,
        ...payload.filter(
          item => !state.users.activeItems.find(a => a.id === item.id),
        ),
      ];

      return {
        ...state,
        users: {
          ...state.users,
          activeItems,
        },
      };
    }

    case CONFERENCES_LIST_PAGE_RESET_USER_FILTERS: {
      const { payload } = action;
      return {
        ...state,
        users: {
          ...state.users,
          data: [],
          total: 0,
          activeItems: payload,
        },
      };
    }
    default:
      return state;
  }
}
